import { CSSObject } from "@emotion/react";

import { colors } from "@dotnet/telematics-design-system";

interface StylesInterface {
  marginBetweenSections?: boolean;
  toLg?: boolean;
}

export const useStyles = ({ marginBetweenSections, toLg }: StylesInterface) =>
  ({
    creditsHistoryPaperTitle: {
      display: "flex",
      justifyContent: "space-between"
    },
    creditsDiv: {
      marginBottom: "16px"
    },
    reservedDiv: {
      marginTop: "16px"
    },
    dialogContentSectionTitle: {
      marginBottom: "8px",
      alignItems: "center"
    },
    singleAccordionItemBlock: {
      display: "flex",
      justifyContent: "space-between"
    },
    itemSeparator: { marginBottom: "16px" },
    creditsGeneralInfoPaper: {
      marginBottom: marginBetweenSections ? "24px" : "0",
      border: `1px solid ${colors.gray200}`
    },
    creditsLineChartAbsoluteDiv: {
      position: "absolute",
      width: "100%",
      height: "inherit"
    }
  }) as CSSObject;
